module.exports = __webpack_public_path__ + "static/crema-de-espinaca-1-699382f77df26e1b296b52bc94f0e1f9.jpg";